import * as React from "react";
import * as VisuallyHiddenPrimitive from "@radix-ui/react-visually-hidden";

const VisuallyHidden = VisuallyHiddenPrimitive.Root;

export { VisuallyHidden };
